import {
  IntegrationAvailability,
  IntegrationAvailabilityApi,
} from "../config/integrations.types";
import { IntegrationType } from "../config/integrations.config";

export const normalizeIntegration = (
  apiIntegration: IntegrationAvailabilityApi
): IntegrationAvailability => ({
  id: apiIntegration.id as IntegrationType,
  enabled: apiIntegration.enabled,
  allowedCountries: JSON.parse(apiIntegration.allowedCountries),
});
